<!--
 * @Description: 人员详情基本信息组件
 * @Author: gaohc
 * @Date: 2022-11-29 11:01:35
-->
<template>
  <div class="baseinfo-wrap">
    <div class="header">
      <img src="../../../../assets/instmng/attendantlist/img-attendant-baseinfo.png" alt="" />
      <div>
        <div>注册信息</div>
        <div class="tag">注册信息包含人员基本信息，为用户注册时所提交信息</div>
      </div>
    </div>
    <div class="body">
      <div>
        <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
          <el-descriptions-item label="所属公司">
            {{baseInfo.institutionText ? baseInfo.institutionText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="姓名">
            {{baseInfo.name ? baseInfo.name : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="手机号">
            {{baseInfo.mobile ? baseInfo.mobile : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="身份证号">
            {{baseInfo.desensitiseIdNo ? baseInfo.desensitiseIdNo : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="年龄">
            {{baseInfo.age ? baseInfo.age : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            {{baseInfo.genderText ? baseInfo.genderText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="服务地区">
            {{baseInfo.cityText ? baseInfo.cityText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="执业开始时间">
            {{baseInfo.practiceStartDate ? baseInfo.practiceStartDate : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="执业年限">
            {{getAttendantSeviceAge ? getAttendantSeviceAge : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="护理员等级">
            {{baseInfo.levelText ? baseInfo.levelText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="服务类别">
            {{baseInfo.serviceType == 10 ? '院内陪护' : '- -'}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="idcard-wrap">
        <div>
          <el-image class="idcard-image" :preview-src-list="previewImgList" 
            :src="urlIdCardImg(baseInfo.idCardImg2Path)" fit="contain">
          </el-image>
          <p>身份证头像页</p>  
        </div>
        <div style="margin-top: 30px">
          <el-image class="idcard-image" :preview-src-list="previewImgList" 
          :src="urlIdCardImg(baseInfo.idCardImg1Path)" fit="contain">
          </el-image>
          <p>身份证国徽页</p>  
        </div>
        <div style="margin-top: 10px;">
            <el-checkbox v-model="baseInfo.showInMainpage" :true-label="1" :false-label="0" disabled>
							用户端机构主页展示Ta的信息
						</el-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["baseInfo"],

  data() {
    return {
      labelStyle : {'margin-bottom': '10px', 'text-align': 'right', 
        'width': '120px', 'display': 'inline-block', 'color': '#657180'},
      contentStyle : {'margin-bottom': '10px', 'color': '#000'}
    }
  },

  computed: {
    getAttendantSeviceAge() {
      if (this.baseInfo && this.baseInfo.practiceStartDate){
        return this.dateUtil.yearsAgoText(this.baseInfo.practiceStartDate, new Date())
      }
    },

    urlIdCardImg() {
      return (image) =>{
        return image ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, 
          image) : '';
      }
    },

    previewImgList() {
      let imgList = [];
      if (this.baseInfo.idCardImg2Path) {
        imgList.push(this.commonUtil.fillUrlArgments
          (this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfo.idCardImg2Path));
      }
      if (this.baseInfo.idCardImg1Path) {
        imgList.push(this.commonUtil.fillUrlArgments
          (this.commonUrl.URL_DOWNLOAD_FILE, this.baseInfo.idCardImg1Path));
      }
      return imgList;
    }
  }
};
</script>

<style scoped>
.baseinfo-wrap {
  background: #f7f9fe;
  padding: 30px 25px 14px 25px;
  margin: 0 25px;
  margin-bottom: 20px;
}

.header {
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  color: #000000;
  font-size: 22px;
}

.header img {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}

.header .tag{
  color: #657180;
  font-size: 13px;
  font-weight: 400;
  margin-top: 12px;
}

.body{
  padding: 35px 120px 0 40px;
  display: flex;
  align-items: flex-start;
}

.baseinfo-wrap /deep/ .el-descriptions__body{
  background: #f7f9fe;
}
.baseinfo-wrap /deep/ .el-descriptions-item__cell{
  padding-bottom: 16px;
}

.idcard-image{
  width: 280px;
  height: 180px;
  background-color: #EBEEF2;
}

.idcard-wrap{
  text-align: center;
}
.idcard-wrap p{
  color: #666666;
  font-size: 13px;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/attendantdetails/AttendantBaseInfo.vue